import { TrendlineType } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import { P, uuid } from '@piccolohealth/util';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormSection } from '../../../../components/forms/FormSection';
import { FormStack } from '../../../../components/forms/FormStack';
import { HookedColorPicker } from '../../../../components/forms/HookedColorPicker';
import { HookedFormField } from '../../../../components/forms/HookedFormField';
import { HookedInput } from '../../../../components/forms/HookedInput';
import { HookedSelect } from '../../../../components/forms/HookedSelect';
import { BadgeItem } from '../../../../components/generic/BadgeItem';
import { COLORS } from '../../../participantData/utils';
import { TrendlineTypeIcon } from './TrendlineTypeIcon';

export const TrendlineForm = () => {
  const { watch, setValue } = useFormContext();
  const trendline = watch('trendline');

  const [isTrendlineVisible, setIsTrendlineVisible] = React.useState(!P.isNil(trendline));

  const onToggleTrendline = (checked: boolean) => {
    if (checked) {
      setIsTrendlineVisible(true);
      setValue(
        'trendline',
        {
          __typename: 'Trendline',
          id: uuid(),
          name: 'Trendline',
          type: TrendlineType.Linear,
          color: COLORS.blue,
        },
        {
          shouldDirty: true,
        },
      );
    } else {
      setIsTrendlineVisible(false);
      setValue('trendline', null, {
        shouldDirty: true,
      });
    }
  };

  return (
    <FormSection
      heading={
        <ChakraV3.HStack>
          Trendline
          <ChakraV3.Spacer />
          <ChakraV3.Switch.Root
            checked={isTrendlineVisible}
            onCheckedChange={(e) => onToggleTrendline(e.checked)}
            size='sm'
          >
            <ChakraV3.Switch.HiddenInput />
            <ChakraV3.Switch.Control />
          </ChakraV3.Switch.Root>
        </ChakraV3.HStack>
      }
      description='Add a trendline to show the general direction of the data'
    >
      {isTrendlineVisible && (
        <>
          <FormStack orientation='horizontal'>
            <HookedFormField name='trendline.name' label='Name'>
              <HookedInput name='trendline.name' placeholder='Trendline name' />
            </HookedFormField>
          </FormStack>
          <FormStack orientation='horizontal'>
            <HookedFormField name='trendline.type' label='Type'>
              <HookedSelect
                name='trendline.type'
                options={[
                  {
                    label: 'Linear',
                    value: TrendlineType.Linear,
                    raw: TrendlineType.Linear,
                  },
                  {
                    label: 'Polynomial',
                    value: TrendlineType.Polynomial,
                    raw: TrendlineType.Polynomial,
                  },
                ]}
                components={{
                  Value: (ps) => (
                    <BadgeItem
                      label={ps.option.label}
                      color={ps.option.color}
                      icon={<TrendlineTypeIcon trendlineType={ps.option.raw} />}
                    />
                  ),
                  Option: (ps) => (
                    <BadgeItem
                      label={ps.option.label}
                      color={ps.option.color}
                      icon={<TrendlineTypeIcon trendlineType={ps.option.raw} />}
                    />
                  ),
                }}
              />
            </HookedFormField>
            <HookedFormField name='trendline.color' label='Color' alignItems='middle'>
              <ChakraV3.HStack h='full' justify='middle'>
                <HookedColorPicker mode='hex' name='trendline.color' />
              </ChakraV3.HStack>
            </HookedFormField>
          </FormStack>
        </>
      )}
    </FormSection>
  );
};
